(function ($) {
  'use strict';
  if ($(".filter-picker").length) {
    $('.filter-picker').each(function () {
      $(this).datetimepicker({
        format: 'YYYY-MM-DD',
        maxDate: new Date(),
        showClear: true,
        useCurrent: false
      });
    });
  }

  if ($(".due-date-picker").length) {
    $('.due-date-picker').each(function () {
      $(this).datetimepicker({
        format: 'YYYY-MM-DD HH:mm',
        minDate: new Date(),
        showClear: true,
        showTodayButton: true,
        icons: {
          time: 'fas fa-clock',
          date: 'fas fa-calendar-alt',
          up: 'fas fa-arrow-up',
          down: 'fas fa-arrow-down',
          previous: 'fas fa-arrow-left',
          next: 'fas fa-arrow-right',
          today: 'fas fa-calendar-check',
          clear: 'fas fa-trash',
          close: 'fas fa-times'
        }
      });
    });
  }

  if ($(".due-date-filter-picker").length) {
    $('.due-date-filter-picker').each(function () {
      $(this).datetimepicker({
        format: 'YYYY-MM-DD',
        showClear: true,
        showTodayButton: true,
        icons: {
          previous: 'fas fa-arrow-left',
          next: 'fas fa-arrow-right',
          today: 'fas fa-calendar-check',
          clear: 'fas fa-trash',
        }
      });
    });
  }
})(jQuery);



// WEBPACK FOOTER //
// ./resources/assets/js/datetimepicker.js